/* eslint-disable react/prop-types */

// components/ReusableModal.jsx
import { useTranslation } from 'react-i18next';
import React from 'react';
import { Modal, Box, Typography, IconButton, Grid, Button } from '@mui/material';
import CloseIconIMG from '../../../images/Icon.svg';
import AlertIcon from '../../../images/alert-circle.png';
import { CDIRAModalStyles as classes } from './CDIRAModalStyles';

const ReusableModal = ({ open, onClose, content }) => {
  const { heading, text1, text2, button1, button2, alertIcon, button1OnClick, button2OnClick } =
    content;

  const { t } = useTranslation();

  return (
    <Modal open={open} onClose={onClose} disablePortal>
      <Box sx={classes.modalStyle}>
        <Grid container sx={{ justifyContent: 'flex-end', display: 'flex' }}>
          <IconButton
            id="businessAddressEdit"
            disableRipple
            name="closeicon"
            onClick={onClose}
            sx={{
              padding: '3px',
              '&:focus-visible': {
                border: '1px solid #000',
                borderRadius: '4px',
              },
            }}
            tabIndex={0}
            data-testid="close_id"
          >
            <img
              src={CloseIconIMG}
              alt="close"
              width="30px"
              height="30px"
              className="smallIconFocus"
            />
          </IconButton>
        </Grid>
        {alertIcon && (
          <Grid container sx={{ justifyContent: 'center', display: 'flex' }}>
            <IconButton
              id="businessAddressEdit"
              disableRipple
              name="closeicon"
              onClick={onClose}
              sx={{ padding: '3px' }}
              data-testid="close_id"
            >
              <img
                src={AlertIcon}
                alt="close"
                width="96px"
                height="96px"
                className="smallIconFocus"
              />
            </IconButton>
          </Grid>
        )}
        <Box sx={classes.contentStyles}>
          <Typography sx={classes.heading}>
            {t(heading, {
              defaultValue: heading,
            })}
          </Typography>
          <Typography sx={classes.subHeading}>
            {t(text1, {
              defaultValue: text1,
            })}
          </Typography>
          {text2 && (
            <Typography sx={classes.subHeading}>
              {' '}
              {t(text2, {
                defaultValue: text2,
              })}
            </Typography>
          )}
        </Box>
        <Box sx={classes.buttonStyles}>
          {button1 && (
            <Button onClick={button1OnClick} sx={classes.button1Style}>
              {t(button1, {
                defaultValue: button1,
              })}
            </Button>
          )}
          {button2 && (
            <Button onClick={button2OnClick} sx={classes.button2Style}>
              {t(button2, {
                defaultValue: button2,
              })}
            </Button>
          )}
        </Box>
      </Box>
    </Modal>
  );
};

export default ReusableModal;
